import { Component, OnInit } from '@angular/core';
import { NgbActiveModal, ModalDismissReasons, NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';

/**
  Componente para mostrar un modal de búsqueda de PNR (Passenger Name Record).
  Este componente permite abrir un modal con opciones configurables,
  como deshabilitar el cierre al hacer clic fuera del modal o presionar la tecla ESC.
  Además, gestiona el resultado del cierre del modal y proporciona una razón de cierre.
**/
@Component({
    selector: 'app-finderpnr-modal',
    templateUrl: './finderpnr-modal.component.html',
    styleUrls: ['./finderpnr-modal.component.scss'],
    standalone: false
})
export class FinderpnrModalComponent implements OnInit {
    /**
    Opciones de configuración del modal.
    - backdrop: 'static' evita que el modal se cierre al hacer clic fuera de él.
    - keyboard: false deshabilita el cierre del modal al presionar la tecla ESC.
  **/
  ngbModalOptions: NgbModalOptions = {
    backdrop : 'static',
    keyboard : false
  };
    /**
    Almacena el resultado del cierre del modal.
  **/
  closeResult = '';
  constructor(
      private modalService: NgbModal,
      public modal: NgbActiveModal
  ) { }

  ngOnInit(): void {
  }

  open(content: any): void {
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason: any) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
 /**
    Obtiene la razón por la cual se cerró el modal.
    @param reason Razón del cierre del modal.
    @return string - Retorna una cadena que describe la razón del cierre.
  **/
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

}
